/**
 * @file
 * NCBE theme support.
 */

((Drupal) => {

  Drupal.behaviors.ncbe_headroom = {
    attach: (context) => {
      // Initialize Headroom
      once('headroom', 'header', context).forEach((el) => {
        const headroom = new Headroom(el, {
          offset: 300,
          tolerance : 10,
        });
        headroom.init();
      });
    }
  };

  Drupal.behaviors.ncbe_hoverintent = {
    attach: (context) => {
      // Initialize hoverintent
      once('hoverintent', '#block-ncbe-main-menu', context).forEach(() => {

        const items = document.querySelectorAll('#block-ncbe-main-menu > ul.menu > li.menu-item');

        if (!items) return;

        const opts = {
          timeout: 250,
        };

        const HOVER_CLASS = 'ncbe-hover-intent';

        for (const item of items) {
          hoverintent(
            item,
            () => {
              // Over
              item.parentElement.querySelectorAll('li').forEach(i => {
                i.classList.remove(HOVER_CLASS);
              });
              item.classList.add(HOVER_CLASS);
            },
            () => {
              // Out
              item.classList.remove(HOVER_CLASS);
            }
          ).options(opts);
        }

      });
    }
  };

})(Drupal, once);
